import { APP_BASE_HREF } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { ApolloModule } from 'apollo-angular';


import { environment } from '../../environments/environment';
import { SharedModule } from '../shared/shared.module';

import { APOLLO_CLIENT_PROVIDER } from './apollo-client-provider';
import { AccountButtonComponent } from './components/account-button/account-button.component';
import { CartDrawerComponent } from './components/cart-drawer/cart-drawer.component';
import { CartToggleComponent } from './components/cart-toggle/cart-toggle.component';
import { CollectionsMenuComponent } from './components/collections-menu/collections-menu.component';
import { LayoutFooterComponent } from './components/layout/layout-footer.component';
import { LayoutHeaderComponent } from './components/layout/layout-header.component';
import { LayoutComponent } from './components/layout/layout.component';
import { MobileMenuOverlayComponent } from './components/mobile-menu-overlay/mobile-menu-overlay.component';
import { ProductListControlsComponent } from './components/product-list-controls/product-list-controls.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import { ProductSearchBarComponent } from './components/product-search-bar/product-search-bar.component';
import { TopReviewsComponent } from './components/top-reviews/top-reviews.component';
import { buildIconLibrary } from './icon-library';
import { DefaultInterceptor } from './providers/data/interceptor';
import { OrderStatusFormComponent } from './components/order-status-form/order-status-form.component';
import { CartPageComponent } from './components/cart-page/cart-page.component';
import { FacetsCarouselComponent } from './components/facets-carousel/facets-carousel.component';
import { CollectionGroupCarouselComponent } from './components/collection-group-carousel/collection-group-carousel.component';
import { ProductCarouselComponent } from './components/product-carousel/product-carousel.component';
import { MarketingBannerComponent } from './components/marketing-banner/marketing-banner.component';
import { KeySellingPointsBannerComponent } from './components/key-selling-points-banner/key-selling-points-banner.component';
import { ProductCarouselV2Component } from './components/product-carousel-v2/product-carousel-v2.component';
import { EmailSubscriptionFormComponent } from './components/email-subscription-form/email-subscription-form.component';
import { CollectionsCarouselComponent } from './components/collections-carousel/collections-carousel.component';
import { ProductSwiperComponent } from './components/product-swiper/product-swiper.component';
import { CollectionSwiperComponent } from './components/collection-group-swiper/collection-group-swiper.component';
import { DualCollectionsSwiperComponent } from './components/dual-collections-swiper/dual-collections-swiper.component';
import { LayoutModule } from '@angular/cdk/layout';
import { PageFooterComponent } from './components/page-footer/page-footer.component';
import { ProductSwiperV2Component } from './components/product-swiper-v2/product-swiper-v2.component';
import { SectionNavMenuComponent } from './components/section-nav-menu/section-nav-menu.component';
import { ExternalHtmlContentComponent } from './components/external-html-content/external-html-content.component';
import { FaqListComponent } from './components/faq-list/faq-list.component';
import { DualCollectionsTilesComponent } from './components/dual-collections-tiles/dual-collections-tiles.component';
import { GeneralPageComponent } from './components/general-page/general-page.component';
import { PageComponent } from './components/page-component/page-component.component';
import { ProductInfoComponent } from './components/product-info/product-info.component';
import { AboutFormComponent } from './components/about-form/about-form.component';
import { ContactFormComponent } from './components/contact-form/contact-form.component';
import { PageHeaderMessagesComponent } from './components/page-header-messages/page-header-messages.component';
import { TextOnlyBannerComponent } from './components/text-only-banner/text-only-banner.component';
import { PromotionLinkComponent } from './components/promotion-link/promotion-link.component';
import { PromotionTermsConditionsModalComponent } from './components/promotion-terms-conditions-modal/promotion-terms-conditions-modal.component';
import { EmptyRouteComponent } from './components/empty.component';
import { DualTextBannerComponent } from './components/dual-text-banner/dual-text-banner.component';
import { CardCarouselBannerComponent } from './components/card-carousel-banner/card-carousel-banner.component';

const CORE_COMPONENTS = [
    ProductListComponent,
    EmptyRouteComponent,
    ProductInfoComponent,
    CartToggleComponent,
    AccountButtonComponent,
    CartDrawerComponent,
    CartPageComponent,
    LayoutComponent,
    LayoutHeaderComponent,
    LayoutFooterComponent,
    MobileMenuOverlayComponent,
    SectionNavMenuComponent,
    CollectionsMenuComponent,
    ProductListControlsComponent,
    ProductCarouselComponent,
    ProductCarouselV2Component,
    MarketingBannerComponent,
    TextOnlyBannerComponent,
    DualTextBannerComponent,
    ExternalHtmlContentComponent,
    KeySellingPointsBannerComponent,
    CardCarouselBannerComponent,
    ProductSearchBarComponent,
    OrderStatusFormComponent,
    FacetsCarouselComponent,
    EmailSubscriptionFormComponent,
    CollectionsCarouselComponent,
    CollectionGroupCarouselComponent,
    CollectionSwiperComponent,
    DualCollectionsSwiperComponent,
    DualCollectionsTilesComponent,
    TopReviewsComponent,
    FaqListComponent,
    AboutFormComponent,
    ContactFormComponent,
    ProductSwiperComponent,
    ProductSwiperV2Component,
    PageFooterComponent,
    PageHeaderMessagesComponent,
    GeneralPageComponent,
    PageComponent,
    PromotionLinkComponent,
    PromotionTermsConditionsModalComponent,
];

@NgModule({
    declarations: [
        ...CORE_COMPONENTS,
    ],
    imports: [
        SharedModule,
        ApolloModule,
        LayoutModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: DefaultInterceptor, multi: true },
        { provide: APP_BASE_HREF, useValue: environment.baseHref },
        APOLLO_CLIENT_PROVIDER,
    ],
    exports: [
        ...CORE_COMPONENTS,
    ],
})
export class CoreModule {
    constructor(library: FaIconLibrary) {
        buildIconLibrary(library);
    }
}
